<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible1" width="800px" :close-on-click-modal="false" @close="close">
    <el-form ref="form" :model="form" label-width="180px">
      <el-form-item label="排序" prop="sort" :required="true">
        <el-input v-model.trim="form.sort" autocomplete="off" placeholder="请输入公告排序"></el-input>
      </el-form-item>
      <el-form-item label="通知标题" prop="title" :required="true">
        <el-input v-model.trim="form.title" autocomplete="off" placeholder="请输入公告标题"></el-input>
      </el-form-item>
      <el-form-item label="通知详情" prop="body" :required="true">
        <baidu-ueditor :content="form.body" @ueditor="getUeditor"></baidu-ueditor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="dialogFormVisible1 = false">{{ $t('common.cancel') }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import baiduUeditor from '@/plugins/baidu-ueditor';
import { getRuleInfo, addRule } from '@/api/set';
export default {
  components: {
    baiduUeditor
  },
  data() {
    return {
      title: '',
      dialogFormVisible1: false,
      form: {
        type: null,
        sort: 1,
        title: '',
        body: ''
      }
    };
  },
  methods: {
    init(id, type) {
      if (id) {
        this.title = '编辑';
        this.getRuleInfo(id);
      } else {
        this.title = '新增';
      }
      if (type) {
        this.form.type = type;
      }
      this.dialogFormVisible1 = true;
    },
    getRuleInfo(id) {
      getRuleInfo({ id: id }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.form, res.data);
        }
      });
    },
    //关闭
    close() {
      this.dialogFormVisible1 = false;
      this.$emit('closeDia');
    },
    //富文本信息返回
    getUeditor(content) {
      this.form.body = content;
    },
    // 保存
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          addRule(this.form).then((res) => {
            if (res.code == 1) {
              this.dialogFormVisible1 = false;
              this.$baseMessage(res.msg, 'success');
              this.$emit('refreshData');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>